import { DeleteIcon } from "@/components/common/icons/DeleteIcon/DeleteIcon"
import { LoadingSpinner } from "@/components/common/LoadingSpinner/LoadingSpinner"
import { Modal } from "@/components/common/Modal/Modal"
import { toast } from "@/components/common/Toast"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import {
  useDeleteQuestionnaire,
  useGetQuestionnairesData,
} from "@/services/api/questionnaireService"
import { useEffect } from "react"
import { useNavigate } from "react-router"

interface DeleteQuestionnaireFromHistoryModalProps {
  questionnaireId: string
  setIsDeleteModalOpen: (isOpen: boolean) => void
  dataTestId?: string
}

export const DeleteQuestionnaireFromHistoryModal: React.FC<
  DeleteQuestionnaireFromHistoryModalProps
> = ({ questionnaireId, setIsDeleteModalOpen, dataTestId }) => {
  const { translate } = useTranslation()
  const navigate = useNavigate()

  const { refetch: refetchQuestionnaires } = useGetQuestionnairesData()

  const {
    mutate: deleteQuestionnaire,
    isPending: isDeleteQuestionnairePending,
    isSuccess: isDeleteQuestionnaireSuccess,
    isError: isDeleteQuestionnaireError,
  } = useDeleteQuestionnaire()

  useEffect(() => {
    if (isDeleteQuestionnaireError) {
      toast.error(translate("QUESTIONNAIRE/DELETE_MODAL/TOAST_DELETE_ERROR"))
    } else if (isDeleteQuestionnaireSuccess) {
      setIsDeleteModalOpen(false)
      refetchQuestionnaires()
      toast.success(
        translate("QUESTIONNAIRE/DELETE_MODAL/TOAST_DELETE_SUCCESS"),
      )
    }
  }, [
    isDeleteQuestionnaireSuccess,
    isDeleteQuestionnaireError,
    navigate,
    setIsDeleteModalOpen,
    refetchQuestionnaires,
    translate,
  ])

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false)
  }

  return (
    <Modal
      ModalIcon={isDeleteQuestionnairePending ? LoadingSpinner : DeleteIcon}
      descriptionText={translate(
        "QUESTIONNAIRE/DELETE_FROM_HISTORY_MODAL/DELETE_TEXT",
      )}
      primaryActionTitle={translate(
        "QUESTIONNAIRE/DELETE_FROM_HISTORY_MODAL/CONFIRM_DELETE",
      )}
      secondaryActionTitle={translate(
        "QUESTIONNAIRE/DELETE_FROM_HISTORY_MODAL/CANCEL_DELETE",
      )}
      onClose={handleCloseDeleteModal}
      onPrimaryAction={() => deleteQuestionnaire(questionnaireId)}
      onSecondaryAction={handleCloseDeleteModal}
      modalTestId={dataTestId}
      primaryActionButtonTestId={"delete-questionnaire"}
      secondaryActionButtonTestId={"keep-questionnaire"}
      showSidebarLeft
    ></Modal>
  )
}
